import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/mastodon': {
    width: 417,
    height: 512,
    paths: [
      {
        d: 'M417.8 179.1C417.8 81.9 354.1 53.4 354.1 53.4 291.6 24.7 125.6 25 63.7 53.4 63.7 53.4 0 81.9 0 179.1 0 294.8-6.6 438.5 105.6 468.2 146.1 478.9 180.9 481.2 208.9 479.6 259.7 476.8 288.2 461.5 288.2 461.5L286.5 424.6S250.2 436 209.4 434.7C169 433.3 126.4 430.3 119.8 380.7 119.2 376.3 118.9 371.7 118.9 366.8 204.5 387.7 277.5 375.9 297.6 373.5 353.7 366.8 402.6 332.2 408.8 300.6 418.6 250.8 417.8 179.1 417.8 179.1zM342.7 304.3H296.1V190.1C296.1 140.4 232.1 138.5 232.1 197V259.5H185.8V197C185.8 138.5 121.8 140.4 121.8 190.1V304.3H75.1C75.1 182.2 69.9 156.4 93.5 129.3 119.4 100.4 173.3 98.5 197.3 135.4L208.9 154.9 220.5 135.4C244.6 98.3 298.6 100.6 324.3 129.3 348 156.6 342.7 182.3 342.7 304.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/mastodon.js
// module id = 4uwm
// module chunks = 144